<template>
  <div class="container">
    <div class="bgcF">
      <div class="nav-tab">
        <div style="display: flex">
          <img src="../../../assets/images/arrow.png" class="ims" alt="" />
          <div>您的当前位置是：首页-{{title?title:"业务系统"}}</div>
        </div>
        <div
          class="hover-underline"
          style="display: flex; margin-right: 56px"
          @click="returnshow"
        >
          <div style="display: inline-block">
            <img src="../../../assets/images/return.png" class="imgs" alt="" />
          </div>
          返回
        </div>
      </div>
      <div class="content">
        <div class="top">
          <div class="title">{{title?title:"业务系统"}}</div>
          <div class="linkage-right">
            <input
              type="text"
              placeholder="请输入"
              v-model="serachFrom.name"
              class="no-outline-input"
            />
            <div class="button hover-underline" @click="search">
              <img src="../../../assets/images/search.png" alt="" />
            </div>
            <div style="width: 30px;font-size: 14px;margin-left: 8px;"@click="reset">
              <div class="hover-underline" style="width: 30px;font-size: 14px;">重置</div>
            </div>
          </div>
          
        </div>
        <div class="xian"></div>
        <ul class="custom-list">
          <li
            v-for="(item, index) in zeroList"
            :key="index"
            @click="item.url?goInfo(item.url):goWeb(item.id)"
          >
            <div class="li-content">
              <div style="display: flex">
                <div class="custom-link hover-underline">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { listbusiness } from '@/api/index'
import { listcolumnZt } from "@/api/pop";
import {imgList} from "@/api/SpecialWork";
export default {
  data() {
    return {
      zeroList: [],
      selectedItem: "支队领导",
      leaderList: [],
      text: "",
      map: null,
      team: "",
      serachFrom: {
        pageNum: 1,
        pageSize: 999,
        status:0,
      },
      oragenFrom: {},
      maker: null,
      teamList: [],
      title: "",
    };
  },
  props: ["otherWeb"],
  mounted() {
    console.log(this.otherWeb,'22222');
    
    if(this.otherWeb==0) {
      this.title = "部门网站"
      this.getImgList()
    }else if(this.otherWeb==1) {
      this.title = "专题专栏"
      this.getColumnList()
    }else if(this.otherWeb==2){
      this.title =""
      this.listbusiness()
    }
  },
  created() {},
  methods: {
    getImgList(){
      const query = {
        pageNum: 1,
        pageSize: 10,
        status:0,
      }
      query.name = this.serachFrom.name
      imgList(query).then(res=>{
        if(res.data.code === 200){
          this.zeroList  = res.data.data.list
        }
      })
    },
    getColumnList(){
      const query = {
        pageNum: 1,
        pageSize: 10
      }
      query.name = this.serachFrom.name
      listcolumnZt(query).then(res=>{
        if(res.data.code === 200){
          this.zeroList  = res.data.data.list
        }
      })
    },
    listbusiness(){
      listbusiness(this.serachFrom).then(res => {
          this.zeroList = res.data.data.list;
      })
    },
    goWeb(id){
      const url = new URL("./specialWork", window.location.origin);
      url.searchParams.append("param", id); // 添加查询参数
      window.open(url.toString(), "_blank");
    },
    goInfo(url) {
        window.open(url, "_blank");
    },
    returnshow() {
      this.$emit("setCilck");
    },
    search(){
      if(this.otherWeb==0) {
        this.getImgList()
      }else if(this.otherWeb==1) {
        this.getColumnList()
      }
      else{
        this.listbusiness()
      }
    },
    reset(){
      this.serachFrom.name = ""
      if(this.otherWeb==0) {
        this.getImgList()
      }else if(this.otherWeb==1) {
        this.getColumnList()
      }
      else{
        this.listbusiness()
      }
    }
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}
.container {
  width: 100%;
  background: #f0f5ff;
  display: flex;
  justify-content: center;
}
.bgcF {
  width: 1120px;
  background-color: #fff;
}
.dispF {
  display: flex;
  margin-bottom: 16px;

  .lingdao {
    width: 64px;
    height: 35px;
    line-height: 35px;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
}
.nav-tab {
  width: 1120;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}

.content {
  width: 1040px;
  margin: 0;
  padding: 40px;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #2b56ac;
    }
  }
  .xian {
    margin-top: 10px;
    width: 1040px;
    height: 1px;
    background-color: #ebebeb;
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.linkage-right {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 186px;
  input {
    width: 110px;
    height: 24px;
    border-radius: 4px 0px 0px 4px;
    border: 1px solid #2b56ac;
  }
  .linkage-right2 {
    width: 136px;
  }
  .no-outline-input {
    outline: none;
  }

  .no-outline-input:focus {
    border-color: #2b56ac;
  }

  .button {
    width: 24px;
    height: 28px;
    background: #2b56ac;
    border-radius: 0px 4px 4px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 11px;
      height: 12px;
    }
  }
}
.custom-list {
  list-style-type: none;
  padding: 0 12px;
  display: flex; /* 使用 Flexbox */
  flex-wrap: wrap; /* 允许换行 */
}

.custom-list li {
  width: calc(50% - 20px); /* 每个 li 宽度为 50% 减去间距 */
  position: relative;
  padding-left: 18px;
  margin: 10px 0;
}

.custom-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: #c1c5cd;
  border-radius: 50%;
}

.li-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  span {
    display: inline-block;
    width: 40px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #ffdfdf;
    border-radius: 4px;
    font-size: 10px;
    color: #cc0000;
    // margin-left: 10px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
</style>
